<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">
      Remplacer le type de rendez-vous
    </div>
    <div class="modal-body">
      <div class="wording">Le type de rendez-vous "<span>{{ typeName }}</span>" est utilisé dans le planning.</div>
      <div class="wording">Sélectionnez un nouveau type pour le remplacer.</div>
      <frg-form-input *ngIf="formGroup" id="selectedType" type="ngSelect"
        [formGroup]="formGroup" [control]="formGroup.get('selectedType')"
        [selectValue]="replacementTypesLabel" [isClearableSelect]="false"
      ></frg-form-input>
      <div class="buttons-container">
        <frg-button (activated)="cancel()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
        <frg-button (activated)="saveType()" [disabled]="!formGroup.valid" *ngIf="formGroup">Valider</frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>